/**
 * Shopify Customer Privacy — labels only
 *
 * The buttons remain Shopify's original controls. This script does not add
 * click handlers, call the Customer Privacy API, or change consent state.
 */
(function () {
  'use strict';

  var labels = {
    '.shopify-pc__banner__btn-accept': 'Accept All Cookies',
    '.shopify-pc__banner__btn-decline': 'Accept Only Necessary',
    '.shopify-pc__banner__btn-manage-prefs': 'Adjust My Preferences'
  };

  function applyLabels() {
    var banner = document.querySelector('#shopify-pc__banner');
    var matchedButtons = 0;

    if (!banner) return false;

    Object.keys(labels).forEach(function (selector) {
      var button = banner.querySelector(selector);

      if (button) {
        matchedButtons += 1;

        if (button.textContent.trim() !== labels[selector]) {
          button.textContent = labels[selector];
        }
      }
    });

    return matchedButtons === Object.keys(labels).length;
  }

  if (!applyLabels()) {
    var observer = new MutationObserver(function () {
      if (applyLabels()) observer.disconnect();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
